// Vehicle types (Batch191, 2026-09-22) - replaced "allocated to a designation" on the
// Vehicle master. A vehicle has exactly one type; STAFF and SALES vehicles must also
// name an employee, the other three may. Codes are what the API stores and filters
// on (App_Vehicle.VehicleType, CHECK-constrained); labels are ours.
export const VEHICLE_TYPES = [
  { value: "ALARMS", label: "Alarms" },
  { value: "OPERATIONS", label: "Operations" },
  { value: "TECHNICAL", label: "Technical" },
  { value: "STAFF", label: "Staff" },
  { value: "SALES", label: "Sales" },
];

export const vehicleTypeRequiresEmployee = (code) => code === "STAFF" || code === "SALES";

export const vehicleTypeLabel = (code) => VEHICLE_TYPES.find((t) => t.value === code)?.label || code || "-";

// Badge class per type - a colour cue only; the label always renders too.
const TYPE_BADGE_CLASS = {
  ALARMS: "badge-linedanger",
  OPERATIONS: "badge-lineinfo",
  TECHNICAL: "badge-linewarning",
  STAFF: "badge-linesecondary",
  SALES: "badge-linesuccess",
};
export const vehicleTypeBadgeClass = (code) => TYPE_BADGE_CLASS[code] || "badge-linesecondary";
